import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
  import Vue from 'vue'

  import Lesson from '@/views/Lesson.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'

  import { useRoute, useRouter } from 'vue-router/composables'

  import type { PropType } from 'vue'
  import type { Nullable } from '@/services/interfaces/Content'
  import type { Lesson as ILesson } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LessonModal',
  props: {
    lessonId: {
      required: true,
      type: String,
    },
    moduleId: {
      required: true,
      type: String,
    },
    courseId: String,
    teaserImageUrl: String,
    formatContent: {
      type: Boolean,
      default: false,
    },
    lessonToRender: {
      type: Object as PropType<ILesson>,
      default: null,
    },
  },
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const router = useRouter()
  const route = useRoute()

  const lesson = ref(null as Nullable<Vue>)

  const getCourseId = computed(() => props.courseId || route.params.courseId)

  const lessonIsForbidden = computed(() => (lesson.value as any)?.forbidden)

  const openLesson = () => {
    emit('close')

    if (lessonIsForbidden.value) return
    router
      .push({
        path: `/courses/${getCourseId.value}/module/${props.moduleId}/lesson/${props.lessonId}`,
        query: { modal: 'true' },
      })
      .catch(() => {
        return
      })
  }

return { __sfc: true,props, emit, router, route, lesson, getCourseId, lessonIsForbidden, openLesson, computed, ref, Vue, Lesson, KetchUpButton, useRoute, useRouter }
}

})